import { render } from "./brands.vue?vue&type=template&id=ab136c08&scoped=true"
import script from "./brands.vue?vue&type=script&lang=js"
export * from "./brands.vue?vue&type=script&lang=js"

import "./brands.vue?vue&type=style&index=0&id=ab136c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab136c08"]])

export default __exports__